import type { PreviewQuotesDataDTO, ProcessesedRowsDTO } from "../types/dtos";
import type { PreviewQuotesData, ProcessesedRows } from "../types/models";
import { transformQuoteDetails } from "~/features/orders/quoteList/api/fetchOrderDetails/transformQuoteDetails";
import { getNextUID } from "~/common/utils/uid";
import { getDate } from "~/common/utils/ApiHelper";

export function transformPreviewItem(dto: PreviewQuotesDataDTO): PreviewQuotesData {
  return {
    quotesDetails: transformQuoteDetails(dto.quote.quotesDetails),
    processesedRows: transformProcessesedRows(dto.quote.processesedRows ?? []),
    quoteNumber: dto.quote.quoteNumber,
  };
}

export function transformProcessesedRows(processesedRows: ProcessesedRowsDTO[]): ProcessesedRows[] {
  return processesedRows.map((item) => {
    return {
      ...item,
      lineItemId: getNextUID(),
      date: getDate(item.date),
    };
  });
}
